<script>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default {
  name: "FancyBoxGallery",
  props: {
    options: Object,
  },
  mounted() {
    Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });
  },
  unmounted() {
    Fancybox.unbind(this.$refs.container);
  },
}
</script>

<template>
  <div ref="container">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
</style>